import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import nb from "./Images/neobot.gif";

function NeoBot_Pizza() {
  const userEmail = sessionStorage.getItem("userEmail");
  const navigate = useNavigate();

  const greetedRef = useRef(false);
const SILENCE_THRESHOLD = 0.01; // adjust as needed

  // control the audio loop
  const isRecordingRef = useRef(false);
  const shouldRestartRef = useRef(true); // set false when paused (e.g., waiting for file load)

  const [greeting, setGreeting] = useState("");
  const [recordingStatus, setRecordingStatus] = useState("");
  const [convertedText, setConvertedText] = useState("");
  const [error, setError] = useState("");
  const [fileResults, setFileResults] = useState({});
  const [folderResults, setFolderResults] = useState([]);
  const [openedFile, setOpenedFile] = useState(null); // {matched_name, url, mimeType, ...}

  const folderUrl =
    "https://drive.google.com/drive/folders/10_Z6n9jyf8tME9FoZGj6BkegoiN2692x";


  useEffect(() => {
    if (!userEmail) navigate("/signin");
  }, [userEmail, navigate]);

  // Speak helper
  const speakAndWait = (text) =>
    new Promise((resolve) => {
      const utter = new SpeechSynthesisUtterance(text);
      utter.onend = () => resolve();
      speechSynthesis.speak(utter);
    });

  const scheduleRestart = (ms = 3000) => {
    if (!shouldRestartRef.current) return;
    setTimeout(() => recordAudioAndConvert(), ms);
  };

  // Generate greeting based on time
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 18) return "Good afternoon";
    return "Good evening";
  };

// On load, say greeting once
useEffect(() => {
  if (!greetedRef.current) {
    greetedRef.current = true;

    const now = new Date();
    const hour = now.getHours();
    const timeGreeting = hour < 12 ? "morning" : hour < 15 ? "afternoon" : "evening";

    const namePart = userEmail ? userEmail.split("@")[0] : "user";
    const fullGreeting = `Hi, good ${timeGreeting}`;

    setGreeting(fullGreeting);
    speakAndWait(fullGreeting).then(() => {
      // start recording loop after greeting
      recordAudioAndConvert();
    });
  }
}, [userEmail]);

const clearScreen = () => {
  setConvertedText("");
  setError("");
  setFileResults({});
  setFolderResults([]);
  setOpenedFile(null);
};


  //  Record audio and send to backend
  const recordAudioAndConvert = async () => {
    if (isRecordingRef.current) return; // avoid overlap
    isRecordingRef.current = true;

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const mediaRecorder = new MediaRecorder(stream);
      const audioChunks = [];

      setRecordingStatus("Recording...");
      setConvertedText("");
      setError("");

      mediaRecorder.ondataavailable = (e) => audioChunks.push(e.data);


    mediaRecorder.onstop = async () => {
      // === NEW: Silence detection ===
      const audioBlob = new Blob(audioChunks, { type: "audio/wav" });
      const arrayBuffer = await audioBlob.arrayBuffer();
      const audioCtx = new AudioContext();
      const decoded = await audioCtx.decodeAudioData(arrayBuffer);

      const channelData = decoded.getChannelData(0);
      const rms =
        Math.sqrt(
          channelData.reduce((acc, val) => acc + val * val, 0) /
            channelData.length
        );

if (rms < SILENCE_THRESHOLD) {
  setRecordingStatus("Silence detected, stopping.");
  isRecordingRef.current = false;
  stream.getTracks().forEach((t) => t.stop());

  // Instead of stopping forever, schedule a retry
  shouldRestartRef.current = true; 
  scheduleRestart(2000); // retry after 2 sec
  return;
}
      // === END silence detection ===


        setRecordingStatus("Uploading audio...");

        const formData = new FormData();
        const userPath = `/var/www/neobot/myflaskapp/flask_static/${userEmail}/NeoBot_Pizza`;
        formData.append("audio", audioBlob, "recorded_audio.wav");
        formData.append("path", userPath);

        let localShouldRestart = true; // will be false if waiting for file load

        try {
          const uploadRes = await fetch("https://neobot.d-rosa.ai/api/upload_audio", {
            method: "POST",
            body: formData,
          });
          const uploadData = await uploadRes.json();

          const speechForm = new FormData();
          speechForm.append("path", uploadData.converted_path);

          const speechRes = await fetch("https://neobot.d-rosa.ai/api/NEOSPEECHTOTXT", {
            method: "POST",
            body: speechForm,
          });
          const speechData = await speechRes.json();

          if (speechRes.ok && speechData.original_text) {
            const textRaw =
              (speechData.original_text || "").toLowerCase().trim();
            setConvertedText(textRaw);
            setRecordingStatus("Transcription complete");

            // Regex intent parse (extended)
           const openMatch = textRaw.match(
  /\b(i need|we need|i want|we want|open|open up|show|display|run|download|launch|execute|access|load|retrieve|view|present|expose|render|activate|initialize|start|call|engage|bring up|unveil|introduce)\s+(.+)/i
);
            const showMatch = textRaw.match(/\b(show|display|list|pizza|pdf)(?:\s+(.*))?/i);

            const closeMatch = textRaw.match(/\b(close|close the file)\b/i);

            // NLP parsing
            let verbs = [];
            let nouns = [];
            try {
              const nlpRes = await fetch("/nlpapi", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ text: speechData.original_text }),
              });
              const nlpData = await nlpRes.json();
              verbs = (nlpData.verbs || []).map((v) =>
                String(v).toLowerCase()
              );
              nouns = (nlpData.nouns || []).map((n) =>
                String(n).toLowerCase()
              );
            } catch (nlpErr) {
              console.warn("NLP error, fallback only:", nlpErr);
            }



// --- Extra Synonyms for "show document list" ---
// Verbs (different tones)
const documentVerbs = [
  "provide", "share", "send", "show", "display", "furnish", "forward",
  "supply", "present", "list", "give", "tell"
];

// Nouns (documents in different words)
const documentNouns = [
  "documents", "files", "paperwork", "records", "materials", "references",
  "documentation", "docs", "papers", "reports", "requirements"
];



            // ---------- INTENT HANDLERS ----------
const wantsOpen =
  (verbs &&
    verbs.some((v) =>
      [
        "open",
        "open up",
        "launch",
        "run",
        "execute",
        "access",
        "load",
        "retrieve",
        "view",
        "present",
        "expose",
        "render",
        "activate",
        "initialize",
        "start",
        "call",
        "engage",
        "bring",
        "bring up",
        "unveil",
        "introduce",
        "download",
        "draw",
        "display",
        "show",
        "show me",
        "help me with",
        "i need",
        "we need",
        "help us with",
        "drawing",
      ].includes(v)
    )) ||
  !!openMatch;

            const wantsShow =
              (verbs &&
                verbs.some((v) =>
                  [
                    "show",
                    "display",
                    "bring",
                    "bring up",
                    "draw",
                    "show me",
                    "help me with",
                    "i need",
                    "we need",
                    "help us with",
                    "drawing",
                  ].includes(v)
                )) ||
              !!showMatch;

            const wantsClose =
              (verbs && verbs.includes("close")) || !!closeMatch;

const wantsDocumentsList =
  (verbs && verbs.some((v) => documentVerbs.includes(v.toLowerCase()))) ||
  (nouns && nouns.some((n) => documentNouns.includes(n.toLowerCase()))) ||
  /\b(documents?|docs?|files?|paperwork|records|materials|documentation)\b/i.test(textRaw);


            // ---------- EXTRA OBJECT KEYWORDS ----------
            const objectWords = [
              "mould",
              "mold",
              "manual",
              "picking",
              "operations",
              "tools",
              "plf",
              "hydax",
              "pdf",
              "inspection",
              "aluminium",
              "report",
              "invoice",
              "laser",
              "welding",
              "50",
              "100",
              "200",
              "300",
              "400",
              "500",
              "machine",
              "machinery",
              "air",
              "guage",
              "assem",
              "assembly",
              "catalogue",
              "brochure",
              "exploded",
              "explode",
              "bearing",
              "brouching",
              "body",
              "cover",
              "final",
              "initial",
              "cnc",
              "maintenance",
              "check",
              "checklist",
              "egico",
              "electrical",
              "fire",
              "training",
              "document",
              "documentation",
              "flexible",
              "shaft",
              "grinder",
              "grind",
              "gear",
              "hobbing",
              "ratio",
              "calculation",
              "procedure",
              "google",
              "site",
              "process",
              "chart",
              "revision",
              "hub",
              "shipping",
              "label",
              "sintered",
              "bronze",
              "filter",
              "six",
              "sigma",
              "guide",
              "flat",
              "round",
              "tap",
              "scanner",
              "spares",
              "loctite",
              "hy",
              "mandrill",
              "manifest",
            ];

            // ---------- DETECTION LOGIC ----------
            const matchedObject = nouns.find((n) =>
              objectWords.includes(n.toLowerCase())
            );

           // CLOSE
if (wantsClose && openedFile) {
  setRecordingStatus("Closing file�");
  setOpenedFile(null);
  shouldRestartRef.current = false; // pause auto-restart
  localShouldRestart = false;

  // Speak "Thank you. Do you want another document?"
  await speakAndWait("Thank you. Do you want another document?");

  try {
    const stream2 = await navigator.mediaDevices.getUserMedia({ audio: true });
    const mediaRecorder2 = new MediaRecorder(stream2);
    const audioChunks2 = [];

    mediaRecorder2.ondataavailable = (e) => audioChunks2.push(e.data);

    mediaRecorder2.onstop = async () => {
      const audioBlob2 = new Blob(audioChunks2, { type: "audio/wav" });
      const formData2 = new FormData();
      formData2.append("audio", audioBlob2, "response.wav");
      formData2.append("path", `/var/www/neobot/myflaskapp/flask_static/${userEmail}/NeoBot_Pizza`);

      try {
        const uploadRes2 = await fetch("https://neobot.d-rosa.ai/api/upload_audio", {
          method: "POST",
          body: formData2,
        });
        const uploadData2 = await uploadRes2.json();

        const speechForm2 = new FormData();
        speechForm2.append("path", uploadData2.converted_path);

        const speechRes2 = await fetch("https://neobot.d-rosa.ai/api/NEOSPEECHTOTXT", {
          method: "POST",
          body: speechForm2,
        });
        const speechData2 = await speechRes2.json();

        if (speechRes2.ok && speechData2.original_text) {
          const responseText = speechData2.original_text.toLowerCase().trim();

          if (responseText.includes("yes")) {
            await speakAndWait("Okay, please tell me the document name.");
            shouldRestartRef.current = true;
            recordAudioAndConvert(); // resume immediately
          } else if (responseText.includes("no")) {
            await speakAndWait("Thanks, have a good day.");
            shouldRestartRef.current = false; // pause for 5s
            setTimeout(() => {
              shouldRestartRef.current = true;
              recordAudioAndConvert(); // restart fresh
            }, 3000); // restart after 5 sec
          } else {
            await speakAndWait("I didn't understand. Let's continue.");
            shouldRestartRef.current = true;
            recordAudioAndConvert();
          }
        }
      } catch (err2) {
        console.error("Error in Yes/No listening:", err2);
        await speakAndWait("Error processing response, continuing.");
        shouldRestartRef.current = true;
        recordAudioAndConvert();
      } finally {
        stream2.getTracks().forEach((t) => t.stop());
      }
    };

    mediaRecorder2.start();
    setTimeout(() => mediaRecorder2.stop(), 5000); // listen 4 sec
  } catch (micErr2) {
    console.error("Mic error for yes/no:", micErr2);
    await speakAndWait("Couldn't capture your response, continuing.");
    shouldRestartRef.current = true;
    recordAudioAndConvert();
  }
}
           // OPEN (file)
else if (wantsOpen) {
clearScreen();   // clear before opening
  const candidate =
    (openMatch && openMatch[2]) ||
    (matchedObject
      ? matchedObject
      : nouns.length > 0
      ? nouns.join(" ")
      : "");

  if (candidate) {
    setRecordingStatus("Loading file�");
    setError("");
    shouldRestartRef.current = false;
    localShouldRestart = false;

    // ?? Modified: Send candidate to backend search for partial match
    const openRes = await fetch("https://neobot.d-rosa.ai/api/openfile", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        filtered_text: candidate, // partial text allowed
        folder_url: folderUrl,
        allow_partial: true       // let backend handle fuzzy/partial
      }),
    });

    const openData = await openRes.json();
    if (openData.success) {
      setOpenedFile(null);
      setOpenedFile(openData);
    } else {
      setError(openData.error || "File not found");
      shouldRestartRef.current = true;
      localShouldRestart = true;
    }
  }
}
            // SHOW (list files/folders)
            else if (wantsShow) {
             const spokenText = speechData.original_text.toLowerCase().trim();

const listAllKeywords = [
  "document", "documents",
  "file", "files",
  "pizza",
  "everything", "all",
  "pdf", "pdfs",
  "list", "lists",
  "out",
  "show", "display"
];

// Match if spokenText equals "list" or "lists" OR contains any keyword
const shouldListAll =
  spokenText === "list" ||
  spokenText === "lists" ||
  spokenText === "display" ||
  spokenText === "show" ||

  listAllKeywords.some((kw) => spokenText.includes(kw));

              if (shouldListAll) {
                const searchRes = await fetch("https://neobot.d-rosa.ai/api/filesearch", {
                  method: "POST",
                  headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    filtered_text: "",
                    folder_url: folderUrl,
                  }),
                });

                const searchData = await searchRes.json();
                if (searchData.success) {
                  setFileResults(searchData.matches);
                  setFolderResults(searchData.folders);

                  const fileCount = Object.values(
                    searchData.matches
                  ).flat().length;
                  const folderCount = searchData.folders.length;
                  await speakAndWait(
                    `I found ${fileCount} files and ${folderCount} folders.`
                  );
                } else {
                  setError(searchData.error || "Search failed");
                }
              } else {
                const query =
                  (showMatch && showMatch[2]) ||
                  (matchedObject
                    ? matchedObject
                    : nouns.length > 0
                    ? nouns[0]
                    : "");
                if (query) {
                  const searchRes = await fetch("https://neobot.d-rosa.ai/api/filesearch", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                      filtered_text: query,
                      folder_url: folderUrl,
                    }),
                  });

                  const searchData = await searchRes.json();
                  if (searchData.success) {
                    setFileResults(searchData.matches);
                    setFolderResults(searchData.folders);
                  } else {
                    setError(searchData.error || "Search failed");
                  }
                } else {
                  setError("Couldn't detect what to show");
                }
              }
            } 
// DOCUMENT LIST (formal / neutral / casual phrasings)
else if (wantsDocumentsList) {
  const searchRes = await fetch("https://neobot.d-rosa.ai/api/filesearch", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      filtered_text: "",   // empty = fetch all docs
      folder_url: folderUrl,
    }),
  });

  const searchData = await searchRes.json();
  if (searchData.success) {
    setFileResults(searchData.matches);
    setFolderResults(searchData.folders);

    const fileCount = Object.values(searchData.matches).flat().length;
    const folderCount = searchData.folders.length;

    await speakAndWait(
      `I found ${fileCount} files and ${folderCount} folders in the documents list.`
    );
  } else {
    setError(searchData.error || "Couldn't fetch documents list");
  }
}

else {
              setRecordingStatus("No command detected, continuing�");
              await speakAndWait(
                "Hi, what kind of pizza you looking for?"
              );
            }
          } else {
            setError(speechData.error || "Speech recognition failed");
          }
        } catch (err) {
          console.error("Audio processing error:", err);
          setError("Processing error");
        } finally {
          stream.getTracks().forEach((track) => track.stop());
          isRecordingRef.current = false;
          shouldRestartRef.current = localShouldRestart;
          scheduleRestart(2000);
        }
      };

      mediaRecorder.start();
      setTimeout(() => mediaRecorder.stop(), 4000);
    } catch (err) {
      console.error("Mic error:", err);
      setError("Microphone access denied.");
      isRecordingRef.current = false;
      scheduleRestart(1500);
    }
  };


  const handleViewerLoaded = () => {
    setRecordingStatus("File loaded");
    shouldRestartRef.current = true;
    scheduleRestart(2000);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>Pizza</h1>
      <p>Signed in as: {userEmail}</p>
      {greeting && <h2>{greeting}</h2>}

      {/* Floating NeoBot icon */}
      <div
        style={{
          position: "fixed",
          top: "15px",
          left: "15px",
          zIndex: 1000,
        }}
      >
        <img src={nb} alt="NeoBot" width="80" height="80" />
      </div>

{/* Info Panel with Scrollbar */}
<div className="scroll-container">
  {recordingStatus && (
    <p>
      <strong>Status:</strong> {recordingStatus}
    </p>
  )}
  {error && (
    <p style={{ color: "red" }}>
      <strong>Error:</strong> {error}
    </p>
  )}
  {convertedText && (
    <p>
      <strong>Speech-to-Text:</strong> {convertedText}
    </p>
  )}

  {/* NLP-driven File Search Results */}
  {Object.keys(fileResults).length > 0 && (
    <div>
      <h4>Manual Instructions:</h4>
      {Object.entries(fileResults).map(([folderPath, files]) => (
        <div key={folderPath}>
                  <ul>
            {files.map((f, idx) => (
              <li key={idx}>{f.name}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  )}

  {folderResults.length > 0 && (
    <div>
      <h4>Subfolders:</h4>
      <ul>
        {folderResults.map((f, idx) => (
          <li key={idx}>
            {f.name} ({f.path})
          </li>
        ))}
      </ul>
    </div>
  )}

  {/* Opened File Viewer */}
  {openedFile && (
    <div style={{ marginTop: "10px" }}>
      <h4>Opened File: {openedFile.matched_name}</h4>
      {openedFile.mimeType === "application/pdf" ? (
        <iframe
          title="pdf-viewer"
          src={openedFile.url}
          style={{
            width: "100%",
            height: "300px",
            border: "1px solid #ccc",
          }}
          onLoad={handleViewerLoaded}
        />
      ) : openedFile.mimeType.startsWith("image/") ? (
        <img
          src={openedFile.url}
          alt={openedFile.matched_name}
          style={{ maxWidth: "100%", maxHeight: "300px" }}
          onLoad={handleViewerLoaded}
          onError={() => {
            setError("Failed to load image");
            shouldRestartRef.current = true;
            scheduleRestart(1500);
          }}
        />
      ) : (
        <p>Unsupported file type</p>
      )}
    </div>
  )}
</div>

      {/* Custom Scrollbar CSS */}
      <style>
        {`
          .scroll-panel::-webkit-scrollbar {
            width: 10px;
          }
          .scroll-panel::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 10px;
          }
          .scroll-panel::-webkit-scrollbar-thumb {
            background: linear-gradient(180deg, #007bff, #00c6ff);
            border-radius: 10px;
          }
          .scroll-panel::-webkit-scrollbar-thumb:hover {
            background: linear-gradient(180deg, #0056b3, #0096c7);
          }
/* Scrollable container with Cream theme */
.scroll-container {
  width: 400px;
  height: 300px;
  margin: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: scroll;
  border: 3px solid #d2b48c;  /* Tan border */
  border-radius: 16px;

  /* ? Cream-inspired moving gradient */
  background: linear-gradient(
    135deg,
    #fffaf0 0%,   /* Floral White */
    #f5f5dc 50%,  /* Beige */
    #fdf5e6 100%  /* Old Lace */
  );
  background-size: 300% 300%;
  animation: creamGradient 10s ease infinite;

  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.2);
  padding: 14px;
  text-align: left;
  color: #2c2c2c;
  font-family: "Trebuchet MS", sans-serif;
  line-height: 1.6;
}

/* Animate gradient with soft cream tones */
@keyframes creamGradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Headings inside container */
.scroll-container h4 {
  color: #8b4513; /* Saddle Brown */
  margin-bottom: 10px;
  border-bottom: 2px solid #8b4513;
  padding-bottom: 5px;
  font-family: "Comic Sans MS", cursive, sans-serif;
}

.scroll-container ul {
  padding-left: 0;
  list-style: none;
}

.scroll-container li {
  list-style: none;
  padding-left: 28px;
  margin: 6px 0;
  color: #333;
  font-weight: 600;
  font-size: 16px;
  position: relative;
}

/* Pizza icon bullets (can swap to cream dot if you want) */
.scroll-container li::before {
  content: "";
  background: url("https://twemoji.maxcdn.com/v/latest/72x72/1f355.png") no-repeat center;
  background-size: 20px 20px;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0;
  top: 2px;
}


        `}

      </style>
    </div>
  );
}

export default NeoBot_Pizza;
